import {PROJECT_BASE_PATH} from '../workspace/multiRunWorkspacePaths';

export const WEAVE_TITLE = 'Weave';
export const WEAVE_SLUG = 'weave';

const PROJECT_WEAVE_TAB = `${PROJECT_BASE_PATH}/:tab(${WEAVE_SLUG})`;

export const PROJECT_WEAVE_PATHS = [
  `${PROJECT_WEAVE_TAB}/:weaveTab/:itemName/versions/:version/:refExtra*`,
  `${PROJECT_WEAVE_TAB}/:weaveTab/:itemName`,
  `${PROJECT_WEAVE_TAB}/:weaveTab`,
  PROJECT_WEAVE_TAB,
];
